var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagePrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7099 15.88L10.8299 12L14.7099 8.12C14.8025 8.02742 14.8759 7.91751 14.9261 7.79655C14.9762 7.67558 15.0019 7.54594 15.0019 7.415C15.0019 7.28407 14.9762 7.15443 14.9261 7.03346C14.8759 6.9125 14.8025 6.80259 14.7099 6.71C14.6173 6.61742 14.5074 6.54398 14.3865 6.49388C14.2655 6.44377 14.1359 6.41798 14.0049 6.41798C13.874 6.41798 13.7443 6.44377 13.6234 6.49388C13.5024 6.54398 13.3925 6.61742 13.2999 6.71L8.70992 11.3C8.61722 11.3925 8.54367 11.5024 8.49349 11.6234C8.44331 11.7444 8.41748 11.874 8.41748 12.005C8.41748 12.136 8.44331 12.2657 8.49349 12.3866C8.54367 12.5076 8.61722 12.6175 8.70992 12.71L13.2999 17.3C13.6899 17.69 14.3199 17.69 14.7099 17.3C15.0899 16.91 15.0999 16.27 14.7099 15.88Z",
    fill: "#8F90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePrev);
export default __webpack_public_path__ + "static/media/page_prev.4ab911fe2d65f4f903018e0e1054ef9e.svg";
export { ForwardRef as ReactComponent };